import { lazy } from 'react';
import { Financing24 } from '@tools/ui/dime';
import type { AppRouter } from '@tools/ui/types';
import { BASE_PATH } from '../constants';

export { BASE_PATH };

const MainView = lazy(
  () => import(/* webpackChunkName: "CatalogV2Main" */ '../pages/MainView')
);

export const catalogV2Routes: AppRouter = {
  modules: [
    {
      redirectFrom: []
    },
    {
      name: 'Transaction Fees',
      path: BASE_PATH,
      component: MainView,
      exact: true,
      icon: Financing24,
      pages: []
    }
  ]
};
